export const ROUTE_NAMES = {
  CATEGORY: 'category',
  TASKS: 'tasks',
  VNC: 'remoteViewer',
  SCHEDULE: 'schedule',
};
